import { render, staticRenderFns } from "./Etapa3.vue?vue&type=template&id=c7538172&scoped=true"
import script from "./Etapa3.vue?vue&type=script&lang=js"
export * from "./Etapa3.vue?vue&type=script&lang=js"
import style0 from "./Etapa3.vue?vue&type=style&index=0&id=c7538172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7538172",
  null
  
)

export default component.exports